import Styles from "./Web.module.css"
import { Grid2, Typography, Box } from "@mui/material";
import tech from "../../../../ui-utils/latestPics/technology.gif"
import research from "../../../../ui-utils/latestPics/research.gif"
import training from "../../../../ui-utils/latestPics/training.gif"
import market from "../../../../ui-utils/latestPics/marketSup.gif"
import { AnimationOnScroll } from "react-animation-on-scroll";
import en from "../../../../i18n/English/Partner/details.json";
import hi from "../../../../i18n/Hindi/Partner/details.json";
import kn from "../../../../i18n/Kannada/Partner/details.json";
import ma from "../../../../i18n/Marathi/Partner/details.json";
import gu from "../../../../i18n/Gujarati/Partner/details.json";
import { useLanguage } from "../../../../Context/LangContext";
export default function InfoWeb(){
    const { language } = useLanguage();
      const translations = { en, hi, kn,gu,ma };
      const t = translations[language];
    return (
    <>
            <Box
                className={Styles.outerBox}
            >

                <AnimationOnScroll animateIn="animate__fadeInDown"
                    animateOnce={true}
                    className={Styles.customFadeInLeft}>

                    <Typography
                        className={Styles.heading}
                    >
                       {t.heading}
                    </Typography>

                </AnimationOnScroll>

                <Box
                    className={Styles.innerBox}>
                            <Box sx={{ width: "100%" }}>
                                <Grid2
                                    container
                                    rowSpacing={5}
                                    columnSpacing={8}
                                >

                                    <Grid2 size={6} className={Styles.mainCard}>
                                        {/* <Item>2</Item> */}
                                  <AnimationOnScroll animateIn="animate__fadeInLeft"
                                    animateOnce={true}
                                    className={Styles.customFadeInLeft} >
                                    <Box className={Styles.cardWrapper1} sx={{ position: 'relative' }}>
                                        <Grid2 className={Styles.circleBackground1} />
                                         <Box className={Styles.card}>
                                            <Box
                                                component="img"
                                                src={research}
                                                alt="Customizable Trading Bots"
                                                sx={{ width: "124px", height: "124px", marginBottom: "8px" }}

                                            />
                                            <Typography
                                                // variant="h6"
                                                className={Styles.title}
                                            >
                                               {t.cards[0].title}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                className={Styles.subtitle}
                                            >
                                                {t.cards[0].subtitle}
                                            </Typography>
                                        </Box>
                                    </Box>
                                        </AnimationOnScroll>
                                    </Grid2>
                                    <Grid2 size={6} className={Styles.mainCard}>
                                        {/* <Item>1</Item> */}
                                      <AnimationOnScroll animateIn="animate__fadeInRight"
                                    animateOnce={true}
                                    className={Styles.customFadeInLeft} >
                                      <Box className={Styles.cardWrapper2} sx={{ position: 'relative' }}>
                                        <Grid2 className={Styles.circleBackground2} />
                                        <Box className={Styles.card}>
                                            <Box
                                                component="img"
                                                src={tech}
                                                alt="Multi Exchange Access"
                                                sx={{ width: "130px", height: "130px" }}
                                                className={Styles.multivectorimgtop}
                                            />
                                            <Typography
                                                // variant="h6"
                                                className={Styles.title}
                                            >
                                                {t.cards[1].title}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                className={Styles.subtitle}
                                            >
                                                {t.cards[1].subtitle}
                                            </Typography>
                                        </Box>
                                       </Box>
                                    </AnimationOnScroll>
                                    </Grid2>
                                    <Grid2 size={6} className={Styles.mainCard}>
                                        {/* <Item>4</Item> */}
                                <AnimationOnScroll animateIn="animate__fadeInLeft"
                                    animateOnce={true}
                                    className={Styles.customFadeInLeft} >
                                    <Box className={Styles.cardWrapper3} sx={{ position: 'relative' }}>
                                        <Grid2 className={Styles.circleBackground3} />
                                        <Box className={Styles.card}>
                                            <Box
                                                component="img"
                                                src={market}
                                                alt="Optimized Trading Strategies"
                                                sx={{ width: "129px", height: "129px" }}
                                            />
                                            <Typography
                                                // variant="h6"
                                                className={Styles.title}
                                            >
                                                {t.cards[2].title}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                className={Styles.subtitle}
                                            >
                                                {t.cards[2].subtitle}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    </AnimationOnScroll>
                                    </Grid2>
                                    <Grid2 size={6} className={Styles.mainCard}>
                                        {/* <Item>3</Item> */}
                                <AnimationOnScroll animateIn="animate__fadeInRight"
                                    animateOnce={true}
                                    className={Styles.customFadeInLeft} >
                                    <Box className={Styles.cardWrapper4} sx={{ position: 'relative' }}>
                                        <Grid2 className={Styles.circleBackground4} />
                                        <Box className={Styles.card}>
                                            <Box
                                                component="img"
                                                src={training}
                                                alt="Diverse Portfolio Management"
                                                sx={{ width: "124px", height: "124px", }}

                                            />
                                            <Typography
                                                // variant="h6"
                                                className={Styles.title}
                                            >
                                                {t.cards[3].title}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                className={Styles.subtitle}
                                            >
                                                {t.cards[3].subtitle}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </AnimationOnScroll>
                                    </Grid2>

                                </Grid2>
                            </Box>
                </Box>
            </Box>
    </>
    )
}